import { Injectable } from '@angular/core';

import * as momentNs from 'moment';
const moment = momentNs;

/**
 * All validations can be performed here
 */
@Injectable()
export class DatepickerValidatorService {
  /**
   * Angualr form errors
   */
  invalidDateError = {
    invalid: {
      valid: false
    }
  };

  maxDateError = {
    maxDate: {
      valid: false
    }
  };

  minDateError = {
    minDate: {
      valid: false
    }
  };

  _maxDate: string;
  _minDate: string;

  get maxDate() {
    return moment(this._maxDate).toDate();
  }

  get minDate() {
    return moment(this._minDate).toDate();
  }

  constructor() { }

  /**
   * Returns if the date is valid
   */
  isValid(value) {
    // valid if true
    if (this.isEmpty(value)) {
      return true;
    }

    // if this.getErrors returns an error then
    // the date is invalid (return false)
    if (!this.isValidDate(value, moment(value, 'MM/DD/YYYY').toDate())) {
      return false;
    }

    return true;
  }

  /**
   * Returns error object in angular form validation
   * format
   */
  getErrors(value) {
    const date = moment(value, 'MM/DD/YYYY').toDate();

    // we don't want to do any validation if the
    // value is empty
    if (this.isEmpty(value)) {
      return null;
    }

    if (!this.isValidDate(value, date)) {
      return this.invalidDateError;
    }

    if (!this.isMaxDate(date, this.maxDate)) {
      return this.maxDateError;
    }

    if (!this.isMinDate(date, this.minDate)) {
      return this.minDateError;
    }

    return null;
  }

  private isEmpty(value) {
    if (!value) {
      return true;
    }

    return value.replace(/\/_+/g, '').length === '';
  }

  private isMaxDate(date, maxDate) {
    if (date > maxDate) {
      return false;
    }
    return true;
  }

  private isMinDate(date, minDate) {
    if (date < minDate) {
      return false;
    }
    return true;
  }

  private isValidDate(value, date) {
    // if moment.js returns invalid
    if (date.toString() === 'Invalid Date') {
      return false;
    }

    // if date length is less than 10 characters after removing
    // the underscores (text mask uses underscore)
    if (value.replace(/_+/g, '').length < 10) {
      return false;
    }

    // if the date year is less than 1900 carefirst considers it
    // invalid
    if (+moment(value).format('YYYY') < 1900) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-validator.service.ts